import apiClient from "../helper/apiClient";
import { validateUserKey } from "./validateUserKey";

export default async function callSalesforceAPISync(requestObject, userKey) {
  validateUserKey(userKey);
  try {
    const { data } = await apiClient.patch("api/saveCallDetailsToCRM", {
      ...requestObject,
      userKey,
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
